import { render, staticRenderFns } from "./PackagesStateChart.vue?vue&type=template&id=6bd59a1c&scoped=true"
import script from "./PackagesStateChart.vue?vue&type=script&lang=js"
export * from "./PackagesStateChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd59a1c",
  null
  
)

export default component.exports